// src/pages/AccountCountdown.js
import '../styles/AccountCountdown.css';
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import WaveText from '../countdown/WaveText';

const AccountCountdown = ({ onCountdownFinish }) => {
  // Définir la date cible (par exemple, lancement d'une fonctionnalité ou événement)
  const targetDate = new Date("2025-02-20T20:50:59");
  //const targetDate = new Date("2025-02-21T23:59:59");

  const calculateTimeLeft = () => {
    const difference = targetDate - new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        jours: Math.floor(difference / (1000 * 60 * 60 * 24)),
        heures: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        secondes: Math.floor((difference / 1000) % 60)
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    timerComponents.push(
      <div key={interval} className="time-segment">
        <span className="time-value">{timeLeft[interval]}</span>
        <span className="time-label">{interval}</span>
      </div>
    );
  });

    useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      // Déclencher la fin du compte à rebours
      if (Object.keys(newTimeLeft).length === 0) {
        onCountdownFinish();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, onCountdownFinish]); // Ajout de onCountdownFinish aux dépendances

  // Remplacez "YOUR_VIDEO_ID" par l'identifiant réel de votre vidéo YouTube.
  const videoId = "jHv1ycLSrX4";

  return (

    <div className="cinema-countdown">
      {/* Vidéo de fond */}
      <div className="background-video">
        <iframe
  src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=0&modestbranding=1&loop=1&playlist=${videoId}`}
  title="Vidéo de fond"
  frameBorder="0"
  allow="autoplay; fullscreen"
  allowFullScreen
></iframe>
      </div>
      {/* Overlay sombre */}
      <div className="overlay"></div>
      {/* Contenu */}
      <div className="content">
        <motion.h1
          className="countdown-title"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <div style={{ padding: '2rem', textAlign: 'center' }}>
      <WaveText text="Bienvenue sur NaninNan, l'épopée cinématographique !" />
</div>
          <div style={{ padding: '2rem', textAlign: 'center' }}>
      <WaveText text="Préparez-vous à vivre l'expérience cinéma digital!" />
</div>
        </motion.h1>
        <motion.p
          className="countdown-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          La salle s'ouvre dans...
        </motion.p>
        <motion.div
          className="countdown-timer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          {timerComponents.length ? timerComponents : <span>Temps écoulé !</span>}
        </motion.div>
        <motion.button
          className="enter-button"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
          onClick={() => window.location.href = "/"} // Redirection vers la page d'accueil ou une autre page
        >
          Patienter dans la salle
        </motion.button>
      </div>
    </div>
  );
};

export default AccountCountdown;
